export default {
  GUEST: "guest",
  STUDENT: "student",
  TEACHER: "partner",
  ADMIN: "admin"
};
